import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography } from '@material-ui/core';
import sgoBear from './bear.svg';
import { useErrorStateStyles } from './styles';

const ErrorState = ({ ...props }) => {
  const { mobile, title } = props;
  const classes = useErrorStateStyles({ mobile });
  return (
    <Paper elevation={0} className={classes.container}>
      <Typography className={classes.regularText}>
        <span className={classes.boldText}>{title}</span>,{' '}
        <span>
          pero ten paciencia, estamos trabajando para entregarte un mejor
          servicio.
        </span>
      </Typography>
      <img src={sgoBear} className={classes.image} />
    </Paper>
  );
};

ErrorState.propTypes = {
  mobile: PropTypes.bool,
  title: PropTypes.string,
};

export default ErrorState;
